import React from 'react'

const ReportsVolumetryHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_555_29414)" />
    <path
      d="M38.8819 19.5V27.264H46.6459L38.8819 19.5ZM36.927 27.264V19.5H26.2585C24.6387 19.5 23.354 20.7847 23.354 22.4045V47.5955C23.354 49.2153 24.6387 50.5 26.2585 50.5H43.7414C45.3612 50.5 46.6459 49.2153 46.6459 47.5955V29.1631H38.9378C37.8207 29.2189 36.927 28.3252 36.927 27.264ZM39.8315 44.691H30.1684C29.6099 44.691 29.2189 44.2441 29.2189 43.7414C29.2189 43.1829 29.6657 42.7919 30.1684 42.7919H39.8873C40.4459 42.7919 40.8369 43.2387 40.8369 43.7414C40.8369 44.3 40.39 44.691 39.8315 44.691ZM39.8315 40.8369H30.1684C29.6099 40.8369 29.2189 40.3901 29.2189 39.8874C29.2189 39.3288 29.6657 38.9378 30.1684 38.9378H39.8873C40.4459 38.9378 40.8369 39.3847 40.8369 39.8874C40.8369 40.3901 40.39 40.8369 39.8315 40.8369ZM40.8369 35.9775C40.8369 36.536 40.39 36.927 39.8873 36.927H30.1684C29.6099 36.927 29.2189 36.4802 29.2189 35.9775C29.2189 35.4189 29.6657 35.0279 30.1684 35.0279H39.8873C40.39 35.0279 40.8369 35.4748 40.8369 35.9775Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_555_29414"
        x1="35"
        y1="11"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
    </defs>
  </svg>
)

export default ReportsVolumetryHome
